import React from 'react';

import { CliveChip } from '~/components/AiChat/CliveChip/CliveChip';
import type { CliveMood } from '~/components/Clive/cliveRegistry';
import { FnolInboxRecordFnolInboxStatus } from '~/server_shared/openapi/data-contracts';

export interface FnolAiInboxStatusChipProps {
  status: FnolInboxRecordFnolInboxStatus;
}

type StatusConfig = {
  [key in FnolInboxRecordFnolInboxStatus]: {
    iconType?: CliveMood;
    content?: string;
  } | null;
};

const STATUS_CONFIG: StatusConfig = {
  [FnolInboxRecordFnolInboxStatus.AiProcessing]: { iconType: 'loading', content: 'Processing' },
  [FnolInboxRecordFnolInboxStatus.Created]: null,
  [FnolInboxRecordFnolInboxStatus.AiProcessingFailed]: { iconType: 'error', content: 'Draft Unavailable' },
  [FnolInboxRecordFnolInboxStatus.New]: null,
  [FnolInboxRecordFnolInboxStatus.NoLobAndSubOrg]: { iconType: 'happy', content: 'No Policy Found' },
  [FnolInboxRecordFnolInboxStatus.AiNew]: { iconType: 'happy', content: 'Review Draft' },
  [FnolInboxRecordFnolInboxStatus.Attached]: null,
  [FnolInboxRecordFnolInboxStatus.Dismissed]: null,
  [FnolInboxRecordFnolInboxStatus.AiPolicyNotFound]: { iconType: 'happy', content: 'No Policy Found' },
};

export const FnolAiInboxStatusChip: React.FC<FnolAiInboxStatusChipProps> = ({ status }) => {
  const statusConfig = STATUS_CONFIG[status];

  if (!statusConfig) {
    // Return null for statuses that don't have a configuration yet
    return null;
  }

  const { iconType, content } = statusConfig;
  return <CliveChip iconType={iconType} content={content} />;
};
